const initState = {
  ManagersBlogs: [],
  myBlogs: [],
  helpRequests: [],
  lastDocumentRequest: "",
  hasMoreRequest: true,
  requests: [],
  lastDocument: null,
  hasMore: true,
  trainingQuizResults: null,
  trainingError: null,
  trainingLoading: false,
};

const managerReducer = (state = initState, action) => {
  switch (action.type) {
    case "ADD_REQUEST":
      return {
        ...state,
        requests: [action.payload, ...state.requests],
      };
    case "FETCH_REQUEST_MANAGER":
      return {
        ...state,
        requests: action.payload.data,
        lastDocument: action.payload.lastVisible,
        hasMore: action.payload.hasMore,
      };
    case "FETCH_MANAGER_REQUESTS_LOAD_MORE":
      return {
        ...state,
        requests: [...state.requests, ...action.payload.data],
        lastDocument: action.payload.lastVisible,
        hasMore: action.payload.hasMore,
      };
    case "DELETE_REQUEST":
      return {
        ...state,
        requests: state.requests.filter(
          (request) => request.id !== action.payload
        ),
      };
    case "EDIT_REQUEST":
      return {
        ...state,
        requests: state.requests.map((request) =>
          request.id === action.payload.id
            ? { ...request, ...action.payload }
            : request
        ),
      };
    case "ADD_MANAGER_HELP_REQUESTS":
      return {
        ...state,
        helpRequests: action.payload.requests,
        lastDocumentRequest: action.payload.lastDocument,
        hasMoreRequest: action.payload.hasMore,
      };
    case "ADD_MANAGER_HELP_REQUESTS_MORE":
      return {
        ...state,
        helpRequests: [...state.helpRequests, ...action.payload.requests],
        lastDocumentRequest: action.payload.lastDocument,
        hasMoreRequest: action.payload.hasMore,
      };
    case "GET_ALL_MANAGER_BLOGS":
      return {
        ...state,
        ManagersBlogs: action.payload,
      };
    case "GET_MANAGER_BLOGS":
      return {
        ...state,
        myBlogs: action.payload,
      };
    case "ADD_MANAGER_BLOGS":
      return {
        ...state,
        myBlogs: [action.payload, ...state.myBlogs],
      };
    case "DELETE_MANAGER_BLOGS":
      let deleteBlog = state.myBlogs.filter(
        (items) => items.id !== action.payload.id
      );
      return {
        ...state,
        myBlogs: deleteBlog,
      };
    case "UPDATE_MANAGER_BLOGS":
      let updateBlog = state.myBlogs.map((item) =>
        item.id == action.payload.id
          ? {
              ...item,
              topic: action.payload.topic,
              description: action.payload.description,
            }
          : item
      );
      return {
        ...state,
        myBlogs: updateBlog,
      };

    // Manager Training Cases
    case "SAVE_QUIZ_RESULTS_SUCCESS":
      return {
        ...state,
        trainingQuizResults: action.payload,
        trainingError: null,
        trainingLoading: false,
      };
    case "SAVE_QUIZ_RESULTS_ERROR":
      return {
        ...state,
        trainingError: action.payload,
        trainingLoading: false,
      };
    case "UPDATE_USER_TO_MANAGER_SUCCESS":
      return {
        ...state,
        trainingError: null,
        trainingLoading: false,
      };
    case "UPDATE_USER_TO_MANAGER_ERROR":
      return {
        ...state,
        trainingError: action.payload,
        trainingLoading: false,
      };
    case "MIGRATE_USER_TRAINING_STATUS_SUCCESS":
      return {
        ...state,
        trainingError: null,
        trainingLoading: false,
      };
    case "MIGRATE_USER_TRAINING_STATUS_ERROR":
      return {
        ...state,
        trainingError: action.payload,
        trainingLoading: false,
      };
    case "MANAGER_TRAINING_LOADING":
      return {
        ...state,
        trainingLoading: true,
        trainingError: null,
      };

    default:
      return {
        ...state,
      };
  }
};
export default managerReducer;
